import methods from "@/config/methods";
import filters from "@/config/filters";
let obj = {
  filters: filters,
  methods: methods
};
export default obj;
